export default class AbstractEntity {
    constructor(data) {
        this.build(data);
    }
    
    build(data) {
        for (const field of Object.keys(data)) {
            if (field === "lastFetchAt") {
                this.lastFetchAt = data.lastFetchAt;
                continue;
            }

            const parts = field.split("_");

            let localField = "_";

            let i = 0;
            for (const part of parts) {
                if (i === 0) {
                    localField += part;
                    i++;
                    continue;
                }

                localField += part.substring(0, 1).toUpperCase() + part.substring(1);
            }

            this[localField] = data[field];
        }
    }
}